import React, {useState} from 'react'
import {AUDIENCE} from '../../../../../utils/constants'
import {Stack, Grid, Typography} from '@mui/material'
import questionResponseTemplate from '../../../../../utils/questionResponseTemplate'
import QuestionCategory from '../../../../../utils/questionCategory'
import Slider from '@mui/material/Slider'
import TextField from '@mui/material/TextField'
import QuestionCategoryBadge from '../QuestionCategoryBadge'

export default function PercentageQuestionRender({
  question,
  audience,
  updateAnswers,
  language,
}) {
  const [response, setResponse] = useState({
    ...questionResponseTemplate,
    questionId: question.id,
    hasNumValue: question.hasCustomValue,
    participantTypeText:
      audience === AUDIENCE.STAFF
        ? 'Staff'
        : audience === AUDIENCE.PARENT
          ? 'Parent'
          : 'Pupil',
    questionTypeText: 'Percentage',
  })

  const marks = [
    {
      value: question.sliderResponseAttributes.rangeTo,
      label:
        AUDIENCE.STAFF === audience
          ? question.sliderResponseAttributes.staffHighScaleLabel
          : AUDIENCE.PARENT === audience
            ? question.sliderResponseAttributes.parentHighScaleLabel
            : question.sliderResponseAttributes.pupilHighScaleLabel,
    },
    {
      value:
        (question.sliderResponseAttributes.rangeFrom +
          question.sliderResponseAttributes.rangeTo) /
        2,
      label:
        AUDIENCE.STAFF === audience
          ? question.sliderResponseAttributes.staffMidScaleLabel
          : AUDIENCE.PARENT === audience
            ? question.sliderResponseAttributes.parentMidScaleLabel
            : question.sliderResponseAttributes.pupilMidScaleLabel,
    },
    {
      value: question.sliderResponseAttributes.rangeFrom,
      label:
        AUDIENCE.STAFF === audience
          ? question.sliderResponseAttributes.staffLowScaleLabel
          : AUDIENCE.PARENT === audience
            ? question.sliderResponseAttributes.parentLowScaleLabel
            : question.sliderResponseAttributes.pupilLowScaleLabel,
    },
  ]

  const shouldRenderFollowup = () => {
    if (question.hasFollowup && question.followupQuestions) {
      switch (question.followupQuestions[0].followupValueOperator) {
        case 1:
          return question.followupQuestions[0].followupValue < response.value1
        case 2:
          return question.followupQuestions[0].followupValue > response.value1
        case 3:
          return question.followupQuestions[0].followupValue === response.value1
        case 4:
          return question.followupQuestions[0].followupValue >= response.value1
        case 5:
          return question.followupQuestions[0].followupValue <= response.value1
      }
    }
    return false
  }
  return (
    <Grid container>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Stack direction="column" alignItems="center" spacing={1.5}>
          {/* <QuestionCategoryBadge categoryName={question.categoryName} /> */}
          <Typography variant="h1">
            {AUDIENCE.STAFF === audience
              ? question.staffText
              : AUDIENCE.PARENT === audience
                ? question.parentText
                : question.pupilText}
          </Typography>
        </Stack>
      </Grid>
      {question.hasDescription && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Typography variant="body1" mb={2} className='ques-desc'>
            {AUDIENCE.STAFF === audience
              ? question.staffDescription
              : AUDIENCE.PARENT === audience
                ? question.parentDescription
                : question.pupilDescription}
          </Typography>
        </Grid>
      )}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <div className="question-type-answer">
          <Stack direction="row" spacing={1} alignItems="center">
            <div>0%</div>

            {/* <Grid item lg={1}>
            0%
          </Grid> */}
            {/* <Grid item lg={10}> */}
            <Slider
              step={1}
              min={question.sliderResponseAttributes.rangeFrom}
              max={question.sliderResponseAttributes.rangeTo}
              marks={marks}
              valueLabelDisplay="auto"
              value={response.value1}
              onChange={(e, v) => {
                let resp = {
                  ...response,
                  value1: v,
                  numValue1: v,
                }

                if (question.categoryId) {
                  let category = QuestionCategory.getQuestionCategoryFromId(
                    question.categoryId
                  )
                  resp.categoryId = question.categoryId
                  resp.categoryName = category ? category.name : null
                }

                resp['staffQuestion'] =
                  language === 'en'
                    ? question.staffText
                    : question.staffTextEnglish
                resp['parentQuestion'] =
                  language === 'en'
                    ? question.parentText
                    : question.parentTextEnglish
                resp['studentQuestion'] =
                  language === 'en'
                    ? question.pupilText
                    : question.pupilTextEnglish

                setResponse({...resp})

                if (updateAnswers) {
                  updateAnswers({...resp})
                }
              }}
            ></Slider>
            {/* </Grid> */}
            {/* <Grid item lg={1}> */}
            <div>100%</div>
            {/* </Grid> */}
          </Stack>
        </div>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <div className="question-type-answer">
          <Stack direction="column" mt={5} rowGap={1} alignItems="start">
            <Typography variant="h2">
              {shouldRenderFollowup()
                ? AUDIENCE.STAFF === audience
                  ? question.followupQuestions[0].staffFollowupText
                  : AUDIENCE.PARENT === audience
                    ? question.followupQuestions[0].parentFollowupText
                    : question.followupQuestions[0].pupilFollowupText
                : ''}
            </Typography>
            {shouldRenderFollowup() ? (
              <TextField
                multiline
                fullWidth
                label="Add follow up answer"
                value={response.followupComment}
                onChange={e => {
                  let resp = {
                    ...response,
                    followupComment: e.target.value,
                    value1: response.value1 === null ? 0 : response.value1,
                    numValue1:
                      response.numValue1 === null ? 0 : response.value1,
                  }

                  resp['staffQuestion'] =
                    language === 'en'
                      ? question.staffText
                      : question.staffTextEnglish
                  resp['parentQuestion'] =
                    language === 'en'
                      ? question.parentText
                      : question.parentTextEnglish
                  resp['studentQuestion'] =
                    language === 'en'
                      ? question.pupilText
                      : question.pupilTextEnglish
                  setResponse({...resp})

                  if (updateAnswers) {
                    updateAnswers({...resp})
                  }
                }}
              ></TextField>
            ) : null}
          </Stack>
        </div>
      </Grid>
    </Grid>
  )
}
